/**
 * Static meeting links (owner decision 2026-10-14, docs/dev/api-appointments.md „Static meeting links"): besides the
 * built-in DAMOKLES meeting room (channel `video`), an event type can take place via Google Meet, Microsoft Teams or
 * Zoom. Each user stores one personal link per service in the profile; a booking snapshots the advisor's link into
 * `appointment.location`. No per-booking link generation, no recording or transcript for these channels.
 */
export const STATIC_VIDEO_CHANNELS = ['google_meet', 'teams', 'zoom'];
export function isStaticVideoChannel(channel) {
    return STATIC_VIDEO_CHANNELS.includes(channel);
}
export const STATIC_VIDEO_CHANNEL_LABELS = {
    google_meet: 'Google Meet',
    teams: 'Microsoft Teams',
    zoom: 'Zoom',
};
/** Every value of the pg enum `event_type_channel` (event type and appointment snapshot). */
export const EVENT_TYPE_CHANNELS = [
    'video',
    ...STATIC_VIDEO_CHANNELS,
    'phone',
    'on_site',
    'property_address',
];
//# sourceMappingURL=appointments.js.map